import axios from "axios";
import { authHeaderJson } from "../auth-header.service";
import { requestExportToken } from "../export.service";

const getReportSiteKpis = async (itemToSend) => {
    const token = await requestExportToken("excel/sitekpis");
    return axios.post(`/api/skVariable/excel/sitekpis?exportToken=${token}`, itemToSend, { headers: authHeaderJson() });
};

const getReportSiteKpiConfigurations = async (itemToSend) => {
    const token = await requestExportToken("excel/sitekpiconfigurations");
    return axios.post(`/api/skVariable/excel/sitekpiconfigurations?exportToken=${token}`, itemToSend, { headers: authHeaderJson() });
};

const getReportSiteKpiActions = async (itemToSend) => {
    const token = await requestExportToken("excel/sitekpiactions");
    return axios.post(`/api/skVariable/excel/sitekpiactions?exportToken=${token}`, itemToSend, { headers: authHeaderJson() });
};

const getReportContractKpiRoles = async (itemToSend) => {
    const token = await requestExportToken("excel/roles/contract");
    return axios.post(`/api/skVariable/excel/roles/contract?exportToken=${token}`, itemToSend, { headers: authHeaderJson() });
};

const getReportGapRevisionActions = async (itemToSend) => {
    const token = await requestExportToken("excel/gap/revisionaction");
    return axios.post(`/api/skgap/excel/gap/revisionaction?exportToken=${token}`, itemToSend, { headers: authHeaderJson() });
};

const getReportGapAnalyzeActions = async (itemToSend) => {
    const token = await requestExportToken("excel/gap/analyzeaction");
    return axios.post(`/api/skgap/excel/gap/analyzeaction?exportToken=${token}`, itemToSend, { headers: authHeaderJson() });
};

const getReportGapAnalyzeComments = async (itemToSend) => {
    const token = await requestExportToken("excel/gap/analyzecomment");
    return axios.post(`/api/skgap/excel/gap/analyzecomment?exportToken=${token}`, itemToSend, { headers: authHeaderJson() });
};

const getReportContracts = async (itemToSend) => {
    const token = await requestExportToken("excel/contracts");
    return axios.post(`/api/contract/excel/contracts?exportToken=${token}`, itemToSend, { headers: authHeaderJson() });
};

const getReportBoardScopeValues = async (itemToSend) => {
    const token = await requestExportToken("board/scopevalues/excel");
    return axios.post(`/api/board/board/scopevalues/excel?exportToken=${token}`, itemToSend, { headers: authHeaderJson() });
};

const getReportBoardScopeConfig = async (itemToSend) => {
    const token = await requestExportToken("board/scopeconfig/excel");
    return axios.post(`/api/board/board/scopeconfig/excel?exportToken=${token}`, itemToSend, { headers: authHeaderJson() });
};

const getReportSiteEdps = async (itemToSend) => {
    const token = await requestExportToken("excel/siteedps");
    return axios.post(`/api/pay/excel/siteedps?exportToken=${token}`, itemToSend, { headers: authHeaderJson() });
};

export {
    getReportSiteKpis,
    getReportSiteKpiConfigurations,
    getReportSiteKpiActions,
    getReportContractKpiRoles,
    getReportGapRevisionActions,
    getReportGapAnalyzeActions,
    getReportGapAnalyzeComments,
    getReportBoardScopeValues,
    getReportBoardScopeConfig,
    getReportContracts,
    getReportSiteEdps,
};
